import { format, isValid, parse } from "date-fns"
import { Locale } from "date-fns/locale"

export const formatStartDate = (date: Date, locale: Locale) => {
  const formattedDate = format(date, "EEE d MMM yyyy", { locale })

  // Capitalize first letter - toLocaleUpperCase handles Unicode correctly for all locales
  if (formattedDate.length === 0) return formattedDate
  return (
    formattedDate[0].toLocaleUpperCase(locale.code) + formattedDate.slice(1)
  )
}

export const validateAndParseDate = (dateString: string): Date | null => {
  if (!dateString) return null

  // Check if the format matches YYYY-MM-DD using regex
  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/
  if (!dateFormatRegex.test(dateString)) {
    return null
  }

  // Parse the date using date-fns
  const parsedDate = parse(dateString, "yyyy-MM-dd", new Date())

  // Check if the parsed date is valid and matches the original string
  // This catches cases like 2024-02-30 (invalid date)
  if (!isValid(parsedDate) || format(parsedDate, "yyyy-MM-dd") !== dateString) {
    return null
  }

  return parsedDate
}

export const formatDateForUrl = (date: Date): string => {
  return format(date, "yyyy-MM-dd")
}

export const convertBirthDateToISO = (input: string): string | null => {
  if (input.length === 8) {
    const parsedDate = parse(input, "yyyyMMdd", new Date())
    if (!isValid(parsedDate)) return null
    return format(parsedDate, "yyyy-MM-dd")
  }

  const parsedDate = parse(input, "yyMMdd", new Date())

  if (!isValid(parsedDate)) {
    return null
  }

  if (parsedDate > new Date()) {
    parsedDate.setFullYear(parsedDate.getFullYear() - 100)
  }

  return format(parsedDate, "yyyy-MM-dd")
}
